<template>
<m-pageframe
    title="{organization-label}: Schedules"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>
    <h2>
        Your Organization's Schedule(s)
    </h2>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-select
        label="Type(s)"
        v-model="types"
        :items="type_choices"
        multiple
        chips
        v-on:input="doUpdate"
    >
    </v-select>


    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        <template v-slot:item="{ item }">
            <tr>

                <td
                    v-for="(header, index) in headers"
                    :key="item.summary_key+'_'+index"
                >
                    <span
                        v-if="header.value == 'label'"
                    >
                        {{item[header.value]}}
                    </span>

                     <span
                        v-else-if="header.value == 'type'"
                    >
                        {{$rc.pretty(item[header.value],'enum_schedule_type')}}
                    </span>

                    <span
                        v-else-if="header.value == 'action'"
                    >
                        <v-menu 
                            bottom 
                            offset-y  
                        >
                        
                        <template v-slot:activator="{ on }">
                                
                            <v-icon 
                                v-on="on"
                            >
                                mdi-dots-vertical-circle-outline
                            </v-icon>
                                
                        </template>
                        
                        <v-list>

                            <v-list-item
                                v-on:click="onClickEdit(item)"
                            >
                                <v-list-item-title>Edit...</v-list-item-title>
                            </v-list-item>

                            <v-divider/>

                            <v-list-item
                                v-on:click="onClickCopy(item)"
                            >
                                <v-list-item-title>Copy...</v-list-item-title>
                            </v-list-item>
                        
                        </v-list>
                        
                        </v-menu> 
                    </span>

                    <m-settings-organization-schedule-cell
                        v-else
                        :item="item"
                        :col="header.value"
                        v-on:click="onClickCell"
                    />
                </td>
                

            </tr>
            
        </template>
    
    </v-data-table>

    <p
        style="margin-top: 15px"
    >
        <b>Hint:</b>  To copy the value from <b>one column</b> between schedules, click on it.
    </p>

   
    <v-card
         v-if="employee_profile != null"
    >
        <v-card-title>
            Your Available Hours
        </v-card-title>
        <v-card-text>
            

            <m-settings-account-available-hours
               
                :profile="employee_profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
            />

        </v-card-text>
    </v-card>


    <m-daily-schedule-dialog
        ref="edit-dialog"
    />

    

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],
            headers: [],
            types: ['endpoint-unavailable-auto-response-schedule-available', 'inbox-active-hours'],
            type_choices: [
                {'text': 'Team Number', 'value': 'endpoint-unavailable-auto-response-schedule-available' },
                {'text': 'Inbox', 'value': 'inbox-active-hours' },
                {'text': 'Widget', 'value': 'widget-on-site-schedule' },
            ],
            employee_profile: null,
        }
    },

    mounted () {
        this.doUpdate();
        this.updateEmployeeProfile();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/schedule/get-profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'type': this.types,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.headers = data.headers;

                        this.headers.push({
                            'text': 'Action',
                            'value': 'action',
                        });
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        updateEmployeeProfile()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/employees/:employee_id',
            
                'params' : {
                        'employee_id': this.$rc.$state.getEmployeeId(),
                    },
            
                'on_success': (data) => {
                        this.employee_profile = data;
                    },
            
                'on_error': 'Unable to get your available hours',
            });
        },

        onClickEdit(item)
        {
            let on_save = (new_schedule) => {
                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PUT: /api/v1/schedule/set-schedule',
                
                    'params' : {
                            'organization_id': this.$route.params.organization_id,
                            'keys': [item.summary_key],
                            'schedule': new_schedule,
                        },
                
                    'on_success': (data) => {
                            this.$rc.snackbar('Schedule updated',2000);
                            this.doUpdate();
                        },
                
                    'on_error': 'Unable to update schedule',
                });
            };

            this.$refs['edit-dialog'].showDialog(item.schedule, on_save);
        },

        onClickCopy(item)
        {
            let choices = [];

            for ( let i = 0; i < this.results.length; i++ )
            {
                let cur = this.results[i];

                if ( cur.summary_key == item.summary_key )
                    continue;

                choices.push({
                    'text': this.getScheduleLabel(cur),
                    'value': cur.summary_key,  
                });
            }

            this.$rc.pick({
                'title': 'Copy schedule to',
                'content_before': 'Copy the schedule from '+this.getScheduleLabel(item)+' to:',
                'content_after': null,
                'choices': choices,
                'multiple': true,
                'type': 'check-box',
                'select_label': 'Choose One',
                'initial_value': null,
                'show_select_all': true,
            
                'on_ok': (value) => {

                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PUT: /api/v1/schedule/set-schedule',
                    
                        'params' : {
                                'organization_id': this.$route.params.organization_id,
                                'keys': value,
                                'schedule': item.schedule,
                            },
                    
                        'on_success': (data) => {
                                this.$rc.snackbar('Schedule copied');
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to update schedules',
                    });

                },
            
                'on_cancel': () => {}
            
            });
        },

        getScheduleLabel(item)
        {
            return this.$rc.pretty(item.type,'enum_schedule_type')+': '+item.label;
        },

        onClickCell(item, col)
        {
            let choices = [];

            for ( let i = 0; i < this.results.length; i++ )
            {
                let cur = this.results[i];

                if ( cur.summary_key == item.summary_key )
                    continue;

                choices.push({
                    'text': this.getScheduleLabel(cur),
                    'value': cur.summary_key,  
                });
            }

            this.$rc.pick({
                'title': 'Copy '+col+' to...',
                'content_before': 'Copy schedule for '+col+' from '+this.getScheduleLabel(item)+' to:',
                'content_after': null,
                'choices': choices,
                'multiple': true,
                'type': 'check-box',
                'select_label': 'Choose One',
                'initial_value': null,
                'show_select_all': true,
            
                'on_ok': (value) => {

                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PUT: /api/v1/schedule/set-column',
                    
                        'params' : {
                                'organization_id': this.$route.params.organization_id,
                                'keys': value,
                                'column': col,
                                'intervals': item[col],
                            },
                    
                        'on_success': (data) => {
                                this.$rc.snackbar('Schedule copied');
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to update schedules',
                    });

                    

                },
            
                'on_cancel': () => {}
            
            });
        },

        onPatchEmployeeAccount(changes)
        {
            changes.employee_id = this.employee_profile.employee_account.employee_id;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.updateEmployeeProfile();
                        this.$rc.snackbar('Your avaialble hours have been updated.', 2000);
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },

        
        
    },
}
</script>

<style lang="scss" scoped>
</style>